import { isLocalUrl } from '../utils';

export default function cardWidget14() {
  const widgetName = 'cardWidget11';
  const widgetOpts = cardWidget11Opts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'edge-to-edge-cards-container-wrapper';

  // function to add custom class
  function customItemsValidation($itemSelected, classStatus) {
    $itemSelected.addClass(classStatus);
  }

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, Description, URL, PurchaseURL } = widgetData[x];
      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
              ${Description ? `<p class="widget-description">${Description}</p>` : ''}
            </div>
          </div>`);
      updateCardButtons($cardItem, URL, PurchaseURL);

      $cardItem.removeClass('void-link');
      validateContent($cardItem, URL, PurchaseURL, Description);
    });
  }

  // function to create buttons
  function updateCardButtons($item, btn1, btn2) {
    const targetMore = isLocalUrl(btn1) ? '' : '_blank';
    const targetBuy = isLocalUrl(btn2) ? '' : '_blank';

    $item.find('.hover-content').append(btn1 || btn2 ? `<div class="widget-button-wrapper">` : '');
    $item
      .find('.widget-button-wrapper')
      .append(btn1 ? `<a href="${btn1}" class="button" target=${targetMore}>${moreLabel}</a>` : '');
    $item
      .find('.widget-button-wrapper')
      .append(btn2 ? `<a href="${btn2}" class="button" target=${targetBuy}>${buyLabel}</a>` : '');
  }

  // ------------------------
  // validate content and custom elements
  function validateContent($item, btn1, btn2, description) {
    if (!btn1 && !btn2 && !description) {
      customItemsValidation($item, 'empty-card');
      return;
    }

    if (!btn1 && !btn2) {
      customItemsValidation($item, 'just-desc');
      return;
    }

    if (btn2) {
      customItemsValidation($item, 'btn-2');
      return;
    }

    if (btn1) {
      customItemsValidation($item, 'btn-1');
    }
  }

  // Label for buttons
  const moreLabel = 'Buy Tickets';
  const buyLabel = 'Buy Premium';

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [],
    showDescription: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.wrap(
          `<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`,
        );
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });
}
